import {hrms, hrmsWithPath} from '../../services/http/api/rest';

const rest = hrmsWithPath('/v1/');

const settings = {
    leaveType: {
        list: () => rest.get('leave-type/all', {},),
        create: (data: any) => rest.post('leave-type', {}, data),
        delete: (id: string) => rest.del('leave-type/{{id}}', {id}),
        updateStatus: (id: string, status: boolean) => rest.put('leave-type/{{id}}', {id}, {}, {'active': status}),
    },
    leaveEntitlement: {
        get: (args?: any) => rest.get('leave-entitlement/search', {}, args),
        create: (data: any) => rest.post('leave-entitlement', {}, data),
        update: (id: string, unit: number) => rest.put('leave-entitlement/{{id}}/unit/{{unit}}', {id, unit}, {}),
        delete: (id: string) => rest.del('leave-entitlement/{{id}}', {id}),
    },
    qualification: {
        list: (args?: any) => rest.get('qualification/find', {}, args),
        create: (data: any) => rest.post('qualification', {}, data),
        update: (data: any, id: string) => rest.put('qualification/{{id}}', {id}, data),
        updateStatus: (id: string, status: boolean) => rest.put('qualification/{{id}}', {id}, null, {active: status}),
        delete: (id: string) => rest.del('qualification/{{id}}', {id}),
    },
    designation: {
        list: (args?: any) => rest.get('designation/find', {}, args),
        create: (data: any) => rest.post('designation', {}, data),
        update: (data: any, id: string) => rest.put('designation/{{id}}', {id}, data),
        updateStatus: (id: string, status: boolean) => rest.put('designation/{{id}}', {id}, undefined, {active: status}),
        delete: (id: string) => rest.del('designation/{{id}}', {id}),
    },
    workWeek: {
        list: () => rest.get('work-week', {},),
        create: (data: any) => rest.post('work-week', {}, data),
        delete: (id: string) => rest.del('work-week/{{id}}', {id}),
    }
}

export default settings;